import React from 'react'
import { Box } from '@chakra-ui/react'
import { Icon } from '@chakra-ui/icons'
import { FaEllipsisVertical } from 'react-icons/fa6'
import { Menu, MenuButton, MenuList } from '@chakra-ui/react'

import { ChatFieldsFragment } from '~graphql/generated/graphql'
import SharedLabel from '~components/shared/form/shared-label'
import GradientDivider from '~components/shared/gradient-divider'
import IconButtonWithTooltip from '~components/shared/icon-button-with-tooltip'
import ExportMessagesAction from './export-messages-action'
import { getWritebackEnabled } from '~utils/helpers'
import ShowSystemMessagesCheckbox from './show-system-checkbox'
import ShowErrorMessagesCheckbox from './show-errors-checkbox'
import MergeChatAction from './merge-chat-action'
import ShowAllLocationsCheckbox from './show-all-locations'
import BlockPhoneNumberAction from '../block-phone-number-button'
import PopOutChatAction from '~components/chats/pop-out-chat-action'

interface Props {
    chat: ChatFieldsFragment
    canShowMessagesForAllLocations: boolean
    showMessagesForAllLocations: boolean
    setShowMessagesForAllLocations: (show: boolean) => void
    /** Hide when the chat is already rendered in a popover. */
    showPopOut?: boolean
}

export default function ChatMoreOptions({
    chat,
    canShowMessagesForAllLocations,
    showMessagesForAllLocations,
    setShowMessagesForAllLocations,
    showPopOut = true,
}: Props) {
    const writebackIsEnabled = getWritebackEnabled(chat.clinic.pms)

    return (
        <Menu>
            <MenuButton
                as={IconButtonWithTooltip}
                icon={<Icon as={FaEllipsisVertical} fontSize="sm" />}
                label="More Options"
                size="xs"
                rounded="full"
                variant="outline"
                h="28px"
                w="28px"
            />
            <MenuList>
                <Box px={3}>
                    <SharedLabel>More Chat Options</SharedLabel>
                </Box>
                <GradientDivider mt={2} mb={1} />
                {showPopOut && <PopOutChatAction chatId={chat.id} />}
                <ShowSystemMessagesCheckbox />
                <ShowErrorMessagesCheckbox />
                {canShowMessagesForAllLocations && (
                    <ShowAllLocationsCheckbox
                        showMessagesForAllLocations={
                            showMessagesForAllLocations
                        }
                        setShowMessagesForAllLocations={
                            setShowMessagesForAllLocations
                        }
                    />
                )}
                <ExportMessagesAction
                    showMessagesForAllLocations={showMessagesForAllLocations}
                    setShowMessagesForAllLocations={
                        setShowMessagesForAllLocations
                    }
                />
                <BlockPhoneNumberAction />
                <MergeChatAction />
                {/* <DownloadMsgsModalButton chat={chat} /> */}
                {/* {writebackIsEnabled && <SaveToPimsModalButton chat={chat} />} */}
            </MenuList>
        </Menu>
    )
}
